<template>
  <div :class="$style.content">
    <div :class="$style.title" id="winners">
      {{ $t("solutionSection.first.winners") }}
    </div>
    <div :class="$style.cta">
      <div :class="$style.links">
        <div v-for="link in links" :key="link.text">
          <a
            :href="link.file"
            target="_blank"
            rel="noopener noreferrer"
            :class="$style.link"
          >
            <div>{{ link.text }}</div>
            <img :src="link.icon" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          text: "2022/23",
          icon: "/icons/arrow.svg",
          file: "/files/22_Winners.pdf",
        },
        {
          text: "2023/24",
          icon: "/icons/arrow.svg",
          file: "/files/23_Winners.pdf",
        },
        {
          text: "2024/25",
          icon: "/icons/arrow.svg",
          file: "/files/24_Winners.pdf",
        },
        {
          text: "2025/26",
          icon: "/icons/arrow.svg",
          file: "/files/25_Winners.pdf",
        },
      ],
    };
  },
};
</script>

<style lang="scss" module>
.title {
  font-family: "Montserrat", sans-serif;
  font-size: 2rem;
  line-height: 1.25;
  font-weight: 600;
  margin: 0 0 2rem 0;
  @include custom(550) {
    font-size: 1.5rem;
  }
  @include custom(385) {
    font-size: 1.3rem;
  }
}
.links {
  width: 100%;
  max-width: 42rem;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
  @include custom(650) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .link {
    height: 100%;
    min-height: 7.5rem;
    background-color: $light-brown;
    border-radius: 0.625rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem;
    cursor: pointer;
    @include custom(550) {
      min-height: 6rem;
      padding: 0.5rem;
      gap: 0.5rem;
    }
    & div {
      font-family: "Montserrat", sans-serif;
      font-weight: 600;
      font-size: 1.4rem;
      line-height: 1;
      white-space: nowrap;
      font-variant-numeric: tabular-nums;
      font-feature-settings: "tnum";
      @include custom(550) {
        font-size: 1.15rem;
      }
    }

    & img {
      width: 3rem;
      height: 3rem;
      @include custom(550) {
        width: 2rem;
        height: 2rem;
      }
    }
  }
}
</style>
